import { render, staticRenderFns } from "./FacetCard.vue?vue&type=template&id=13a585bf&scoped=true&"
import script from "./FacetCard.vue?vue&type=script&lang=ts&"
export * from "./FacetCard.vue?vue&type=script&lang=ts&"
import style0 from "./FacetCard.vue?vue&type=style&index=0&id=13a585bf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a585bf",
  null
  
)

export default component.exports